import React, { forwardRef } from 'react';
import { path, last } from 'ramda';
import { StyledListItem, StyledListItemOverlay, StyledMainContentWrap } from './styled';
export const hasSecondActionChecker = (element) => {
    const name = path(['type', 'displayName'], element);
    if (!name)
        return false;
    return name === 'ListItemSecondAction';
};
export const ListItem = forwardRef(function ListItem({ component = 'li', children: childrenProp, divider = true, button = false, disabled = false, selected, tabIndex: tabIndexProp, onClick, ...props }, ref) {
    // TODO: We should trigger onClick by "space" in focus state
    let tabIndex;
    if (!disabled && button) {
        tabIndex = tabIndexProp !== undefined ? tabIndexProp : 0;
    }
    const children = React.Children.toArray(childrenProp);
    const hasSecondAction = Boolean(children.length) && hasSecondActionChecker(last(children));
    return (React.createElement(StyledListItem, { ref: ref, as: component, "$divider": divider, "$button": button, "$disabled": disabled, ...props },
        React.createElement(StyledMainContentWrap
        // TODO: we should handle SPACE and ENTER key event
        // because it's button
        , { 
            // TODO: we should handle SPACE and ENTER key event
            // because it's button
            role: button ? 'button' : undefined, tabIndex: tabIndex, "aria-disabled": disabled, "$selected": selected, "$divider": divider, "$button": button, "$disabled": disabled, "$hasSecondAction": hasSecondAction, onClick: onClick },
            button && React.createElement(StyledListItemOverlay, { "$divider": divider }),
            children),
        hasSecondAction && children.pop()));
});
